export default "__VITE_ASSET__CcQdWWhd__"